import { apiClient } from './client';

export interface ColumnInfo {
  name: string;
  type: string;
  isNullable: string;
}

export interface TableInfo {
  tableName: string;
  columns: ColumnInfo[];
  hasUpdatedAt: boolean;
}

export interface QueryResultColumn {
  name: string;
  dataTypeID: number;
}

export interface QueryResult {
  columns: QueryResultColumn[];
  rows: Record<string, unknown>[];
  rowCount: number;
}

export interface QueryError {
  message: string;
  detail?: string;
  hint?: string;
  position?: string;
  code?: string;
  where?: string;
}

export async function getTableSchema(): Promise<TableInfo[]> {
  const { data } = await apiClient.get<TableInfo[]>('/admin/sql/tables');
  return data;
}

export async function executeQuery(sql: string): Promise<QueryResult> {
  const { data } = await apiClient.post<QueryResult>('/admin/sql/query', { sql });
  return data;
}
